import { Icon, Typography } from '@/modules/perseo-billing/ui/react/src';

import { SubmittedGiftCardPreview } from '../submitted-gift-card-preview.component';

export const InsufficientBalance = () => {
  return (
    <div className="co-flex co-flex-col co-items-start co-gap-24px">
      <div className="co-bg-[#FFFCE0] co-border-1 co-border-[#DA7400] co-p-8px co-gap-4px co-rounded-8px">
        <div className="co-flex co-items-center co-gap-2">
          <Icon icon="InputWarningIcon" color="black" width={20} height={20} />
          <Typography weight="semibold">
            Elige otro medio de pago adicional
          </Typography>
        </div>

        <Typography
          size="body2"
          className="co-text-pds-neutral-600 co-leading-[20px]"
        >
          El monto de la compra es superior al de tu Gift card, compleméntalo
          con otro medio de pago.
        </Typography>
      </div>
      <SubmittedGiftCardPreview />
    </div>
  );
};
